import { InjectedConnector } from '@web3-react/injected-connector';

export const injected = new InjectedConnector({
  supportedChainIds: [8453, 84531], // Base Mainnet and Goerli Testnet
}); 